<!-- start your-workspace -->
<div class="your-workspace" id="popup-workspace">
  <div class="head">
    <h5>Switch your workspace</h5>
    <mat-form-field appearance="outline">
      <mat-icon matPrefix class="icon-va-filter-list"></mat-icon>
      <input matInput autocomplete="false" type="search" id="" placeholder="Search Workspace" name="account_name" #value
        (input)="applyFilter($event)">
    </mat-form-field>
  </div>
  <div class="lists">
    <ng-container *ngIf="data?.list | searchFilter:searchValue let filteredAccountList;">
      <ng-container *ngIf="filteredAccountList.length>0">
        <div class="title">
          <p>Name</p>
        </div>
      </ng-container>
    </ng-container>



    <mat-accordion class="multi-accordion" [multi]="true">
      <ng-container *ngIf="data?.list | searchFilter:searchValue let filteredAccountList;">
        <ng-container *ngIf="filteredAccountList.length>0 else noSearchView">
          <mat-expansion-panel *ngFor="let account of filteredAccountList let accountIndex=index" [expanded]="true">
            <mat-expansion-panel-header>
              <p><i class="icon icon-va-organisation"></i>{{account?.accountName}}</p>
            </mat-expansion-panel-header>
            <ng-container *ngIf="account?.workspaces.length>0;else workspaceTemp">
              <div class="list" [class.active]="selectedWorkspace?.workspaceHierarchy==workspace?.workspaceHierarchy" *ngFor="let workspace of account?.workspaces | searchFilter:searchValue;let workspaceIndex=index"
                (click)="selectWorkspace(account,workspace)">
                <p>
                  <span class="txt"><i class="icon icon-va-workspace"></i>{{workspace?.workspaceName}}</span>
                  <!-- <span *ngIf="workspace?.workspaceId==this.selectedWorkspace?.workspaceId" class="default-txt">Default</span>
                                    <span *ngIf="workspace?.workspaceId!==this.selectedWorkspace?.workspaceId" class="set-default-txt" >Set as default</span> -->
                </p>
              </div>
            </ng-container>
            <ng-template #workspaceTemp>
              <div class="no-workspace">
                <p>You don't have any shared workspace</p>
              </div>
            </ng-template>
          </mat-expansion-panel>
        </ng-container>
        <ng-template #noSearchView>
          <div class="no-search-text">
            <p>No Search Results Found</p>
          </div>
        </ng-template>
      </ng-container>
    </mat-accordion>
  </div>
</div>
<!-- end your-workspace -->